import type { AxiosResponse } from "axios";

import api from "../utils/AxiosInterceptor";

export async function verifyRecaptcha(token: string): Promise<unknown> {
  const response: AxiosResponse<unknown> = await api.post(
    `/api/v1/recaptcha/verify`,
    { token },
  );
  return response.data;
}
